import React from "react";
import { useOpportunityManagement } from "@/opportunity/OpportunityManagementContext";
import { useOpportunities } from "@/opportunity/api";
import { Banknote, Leaf } from "lucide-react";

const OpportunitiesAggregatedSavings = () => {

  const { filters, sorting, pagination } = useOpportunityManagement();
  const { data: opportunities } = useOpportunities({
    page: pagination.pageIndex + 1,
    pageSize: pagination.pageSize,
    sorting,
    filters,
  });

  if (
    !opportunities.totals || Object.values(opportunities.totals).every((saving) => saving === 0)
  ) {
    return (
      <div>
        Thalo's real-time monitoring never stops. Our algorithms are constantly looking for issues, and we suggest fixes
        that help save you money. You'll reduce emissions too!
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-2">
      <h4 className="text-lg">Total Potential Savings</h4>
      <p>
        Nice! By addressing the issues below, you could save:
      </p>
      <div className="flex flex-col gap-2">
        {
          opportunities.totals.FRP && (
            <div className="flex flex-row gap-2 items-center bg-blue-50 rounded-lg w-fit px-2 py-1">
              <Banknote size={16}/>
              <span>
                <span className="font-bold">${opportunities.totals.FRP.toLocaleString()}</span>
                <span className="font-normal"> on energy</span>
              </span>
            </div>
          )
        }
        {
          opportunities.totals.ERP && (
            <div className="flex flex-row gap-2 items-center bg-green-50 rounded-lg w-fit px-2 py-1">
              <Leaf size={16}/>
              <span>
                <span className="font-bold">{opportunities.totals.ERP.toLocaleString()} tons CO2e</span>
                <span className="font-normal"> of emissions</span>
              </span>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default OpportunitiesAggregatedSavings;